import $ from 'jquery';
import Swiper from 'swiper';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/section-half.css';

import '../css/card-block.css';
import '../css/promotion/book-button.css';
import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';
import '../css/restaurant/prevNext-button.css';
import '../css/contact-block.css';
import '../css/modal-block.css';
import '../css/contact-form.css';
import '../css/success-alert.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { uploadUri } from './appConfig';
import getRestaurantDetail from './request/restaurantDetail';
import getPromotionList from './request/promotionList';
import generateLinkCard from './promotion/generateLinkCard';
import wrapSwiperSlide from './about/wrapSwiperSlide';
import languageBasedTag from './languageBasedTag';
import renderInformation from './restaurant/renderInformation';
import renderMenu from './restaurant/renderMenu';
import toggleModal from '../js/toggleModal';
import generateEmail from './about/generateEmail';
import validateContactForm from './validateContactForm';
import sendMail from './request/sendMail';
import getWordingJson from './request/wordingJson';
import wordingSetter from './wordingSetter';
import urlParser from './urlParser';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

document.querySelector('.contact-block > .content > .modal-marker')
	.addEventListener('click', (e) => toggleModal(e.target));

/**
 * check contact form is not empty and send email
 */
$('.contact-form > .button-effect').on('click', () => {
	if (!validateContactForm()) {
		return;
	}

	const mailContent = {
		name: $('.contact-form > input[name="name"]').val(),
		tel: $('.contact-form > input[name="tel"]').val(),
		email: $('.contact-form > input[name="email"]').val(),
		category: $('.contact-form > .select > select[name="category"]').val(),
		content: $('.contact-form > textarea[name="content"]').val(),
	};

	sendMail(generateEmail(mailContent), () => {
		const $successAlert = $('.contact-form > .success-alert');
		$successAlert.removeClass('-hide');

		setTimeout(() => {
			$successAlert.addClass('-hide');
			$('.contact-form > .item').val('');
			$('.contact-form > .selector > .item').val(0);
			$('.modal-block > .closebtn').trigger('click');
		}, 2000);
	}, (err) => {
		console.error(err);
	});
});

const wordingJsonPromise = getWordingJson('about')
	.then((json) => wordingSetter(json));

const restaurantDetailPromise = getRestaurantDetail(window.location.pathname.split('/')[3])
	.then((json) => {
		document.querySelector('.banner-wrapper').setAttribute(
			'style',
			`background-image: url(${uploadUri}/${json.banner})`,
		);
		document.querySelector('.banner-wrapper > .title').innerText = json.name;
		document.querySelector('.section-block:first-child > .subtitle').innerText = json.type;
		document.querySelector('.section-block:first-child > .title').innerText = json.title;
		document.querySelector('.section-block:first-child > .content').innerText = json.introduction_title;
		document.querySelector('.section-half > .image').setAttribute(
			'style',
			`background-image: url(${uploadUri}/${json.information_img})`,
		);

		/**
		 * detail information
		 */
		if (json.menu.length) {
			renderMenu(json.menu);
		}
		if (json.maps.length) {
			renderMenu(json.maps, 'map');
		}
		json.information.forEach((info) => {
			renderInformation(info);
		});

		/**
		 * images
		 */
		json.photo.forEach((imagePath) => {
			const slide = document.createElement('div');
			slide.setAttribute('class', 'swiper-slide');
			slide.setAttribute(
				'style',
				`background-image: url(${uploadUri}/${imagePath})`,
			);
			document.querySelector('.swiper-wrapper').appendChild(slide);
		});

		/**
		 * page switch
		 */
		document.querySelector('.prevNext-button > .button.-prev > .text').innerText = json.nextPrevious.prevName;
		document.querySelector('.prevNext-button > .button.-prev').setAttribute(
			'href',
			`restaurants/${json.nextPrevious.prevId}`,
		);
		document.querySelector('.prevNext-button > .button.-next > .text').innerText = json.nextPrevious.nextName;
		document.querySelector('.prevNext-button > .button.-next').setAttribute(
			'href',
			`restaurants/${json.nextPrevious.nextId}`,
		);

		/**
		 * swiper initialize
		 */
		Swiper('.swiper-container.-photo', {
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			slidesPerView: 2,
			slidesPerGroup: 2,
			speed: 800,
			centeredSlides: false,
			paginationClickable: true,
			spaceBetween: 50,
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 1,
					slidesPerGroup: 1,
				},
			},
		});

		return json.promotion_type;
	})
	.then((restauRantType) => {
		if (restauRantType === 'meeting') {
			$('.contact-block').removeClass('-hide');
		}

		if (!restauRantType || urlParser.language === 'en') {
			$('.section-block.-promotions').hide();
			return;
		}

		getPromotionList(restauRantType)
			.then((json) => {
				/**
				 * there is promotions data
				 *
				 * End the promise chain, go to the `catch` block
				 */
				if (json.promotions.length === 0) {
					return Promise.reject(new Error('EMPTY_RESPONSE'));
				}

				return json;
			})
			.then((json) => {
				json.promotions.forEach((item) => {
					document.querySelector('.swiper-container.-promotions > .swiper-wrapper').appendChild(
						wrapSwiperSlide(
							generateLinkCard(
								item.id,
								item.type,
								item.title,
								item.date_start,
								`${uploadUri}/${item.thumb}`,
								item.link,
							),
						),
					);
				});

				const slideCount = json.promotions.length;

				Swiper('.swiper-container.-promotions', {
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					speed: 800,
					slidesPerView: 3,
					slidesPerGroup: 1,
					centeredSlides: slideCount < 2,
					spaceBetween: 30,
					loop: slideCount > 3,
					breakpoints: {
						1160: {
							slidesPerView: 2,
							loop: slideCount > 2,
						},
						768: {
							slidesPerView: 1,
							loop: slideCount > 1,
						},
					},
				});
			})
			.catch(() => {
				/**
				 * hide the promotion block
				 */
				document.querySelector('.section-block.-promotions').classList.add('-hide');
			});
	})
	.catch(({ error_msg: errorMsg }) => {
		if (errorMsg === 'NOT_FOUND') {
			window.location.href = 'restaurants';
		}
	});

/**
 * make sure each promise is finished
 */
Promise.all([wordingJsonPromise, restaurantDetailPromise])
	.then(() => hideLoadingImage());




// WEBPACK FOOTER //
// ./src/js/restaurants-info.js